import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import mergeRefs from 'react-merge-refs';
import cn from 'classnames';
import { useSkeleton } from '../hooks/use-skeleton.js';
import { c as colors } from '../colors.module-4991aa3d.js';

var styles = {"paragraph":"typography__paragraph_1h0ey","paragraphWithMargins":"typography__paragraphWithMargins_1h0ey","primary-large":"typography__primary-large_1h0ey","primary-medium":"typography__primary-medium_1h0ey","primary-small":"typography__primary-small_1h0ey","secondary-large":"typography__secondary-large_1h0ey","secondary-medium":"typography__secondary-medium_1h0ey","secondary-small":"typography__secondary-small_1h0ey","component":"typography__component_1h0ey","component-primary":"typography__component-primary_1h0ey","component-secondary":"typography__component-secondary_1h0ey","caps":"typography__caps_1h0ey","bold":"typography__bold_1h0ey","medium":"typography__medium_1h0ey","regular":"typography__regular_1h0ey","monospace":"typography__monospace_1h0ey","rowLimit1":"typography__rowLimit1_1h0ey","rowLimit2":"typography__rowLimit2_1h0ey","rowLimit3":"typography__rowLimit3_1h0ey"};
require('./index.css')

var logWarning = function (view) {
    if (process.env.NODE_ENV !== 'development') {
        return;
    }
    var viewsMap = {
        component: 'component-primary',
    };
    // eslint-disable-next-line no-console
    console.warn(
    // eslint-disable-next-line prefer-template
    "@alfalab/core-components/typography: view='".concat(view, "' \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0435\u043D \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u043C\u0430\u0436\u043E\u0440\u043D\u044B\u0445 \u0432\u0435\u0440\u0441\u0438\u044F\u0445. ") +
        "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 view='".concat(viewsMap[view], "'."));
};
var Text = forwardRef(function (_a, ref) {
    var _b, _c;
    var _d = _a.view, view = _d === void 0 ? 'primary-medium' : _d, _e = _a.tag, Component = _e === void 0 ? 'span' : _e, weight = _a.weight, _f = _a.monospaceNumbers, monospaceNumbers = _f === void 0 ? false : _f, _g = _a.defaultMargins, defaultMargins = _g === void 0 ? true : _g, color = _a.color, className = _a.className, dataTestId = _a.dataTestId, children = _a.children, rowLimit = _a.rowLimit, showSkeleton = _a.showSkeleton, skeletonProps = _a.skeletonProps, restProps = __rest(_a, ["view", "tag", "weight", "monospaceNumbers", "defaultMargins", "color", "className", "dataTestId", "children", "rowLimit", "showSkeleton", "skeletonProps"]);
    if (view === 'component') {
        logWarning(view);
    }
    var _h = useSkeleton(showSkeleton, skeletonProps), renderSkeleton = _h.renderSkeleton, textRef = _h.textRef;
    var skeleton = renderSkeleton({
        wrapperClassName: cn((_b = {},
            _b[styles.paragraphWithMargins] = Component === 'p' && defaultMargins,
            _b)),
        dataTestId: dataTestId,
    });
    if (skeleton) {
        return skeleton;
    }
    return (React.createElement(Component, __assign({ className: cn((_c = {},
            _c[styles.paragraph] = Component === 'p' && !defaultMargins,
            _c[styles.paragraphWithMargins] = Component === 'p' && defaultMargins,
            _c[styles.monospace] = monospaceNumbers,
            _c[styles["rowLimit".concat(rowLimit)]] = rowLimit,
            _c), className, color && colors[color], styles[view], weight && styles[weight]), "data-test-id": dataTestId, ref: mergeRefs([ref, textRef]) }, restProps), children));
});

export { Text };
